/* RESPONSIBLE TEAM: team-inbox */

/**
 * Deduplicates an array of objects by their objectId property.
 * Keeps the first occurrence of each unique objectId.
 *
 * Used to prevent 422 unique constraint errors when ember-sortable
 * produces duplicate objects during drag-drop operations.
 */
export function deduplicateByObjectId<T extends { objectId: number }>(objects: T[]): T[] {
  let seen = new Set<number>();
  return objects.filter((obj) => {
    if (seen.has(obj.objectId)) {
      return false;
    }
    seen.add(obj.objectId);
    return true;
  });
}
